import { NavBar } from "../NavBar";
import {
  useAppDispatch,
  useAppSelector,
  useDeviceDetect,
  useScreenSize,
} from "hooks";
import { MOBILE_WIDTH, TAB_LARGE_WIDTH } from "utils/constants";
import { HamburgerMenu, PrLogoLarge, PrTextLogo } from "components/atoms/Icon";
import { HeaderNotification } from "components/molecules";
import { layout_types, setToggleMobileMenu } from "state/reducers/layoutSlice";
import { CSSTransition } from "react-transition-group";
import { PrLogoSmall } from "components/atoms/Icon/PrLogoSmall";
import { Typography } from "components/atoms/Typography";
import { decodeToken } from "utils/functions/decodeToken";
import "./styles.scss";

interface IProps {
  theme: "light" | "dark";
}

export const Sidebar = ({ theme }: IProps) => {
  const screen = useScreenSize();
  const device = useDeviceDetect();
  const dispatch: any = useAppDispatch();
  const payload = decodeToken();

  const { layoutMode, toggleMobileMenu } = useAppSelector(
    (state: {
      layout: { layoutMode: layout_types; toggleMobileMenu: boolean };
    }) => state.layout
  );

  const isDesktop = screen.width > TAB_LARGE_WIDTH;
  const isMobile = screen.width <= MOBILE_WIDTH;
  const isTab = screen.width <= TAB_LARGE_WIDTH && screen.width > MOBILE_WIDTH;

  return (
    <div className="sidebar-wrapper">
      {isTab || isMobile ? (
        <div className="mobile-header-wrapper">
          <HamburgerMenu
            handleOnClick={() =>
              dispatch(setToggleMobileMenu(!toggleMobileMenu))
            }
          />
          <PrTextLogo />
          <HeaderNotification theme={theme} />
        </div>
      ) : null}

      <CSSTransition
        in={isDesktop || toggleMobileMenu}
        timeout={300}
        classNames="sidebar-anim"
        mountOnEnter
        unmountOnExit
      >
        <div className="side-bar">
          <div className="upper-section-wrapper">
            <div className="nav-logo-wrapper">
              {layoutMode === "toggle-desktop-menu" && !isTab && !isMobile ? (
                <PrLogoSmall />
              ) : (
                <>
                  {isDesktop ? <PrLogoLarge /> : null}

                  {!isMobile && payload?.testtype ? (
                    <Typography
                      styles="nav-wrapper-title"
                      variant="h5Med"
                      label={payload.testtype}
                    />
                  ) : null}
                </>
              )}
            </div>

            <NavBar
              theme={theme}
              isMobile={isMobile}
              isDesktop={isDesktop}
              isTab={false}
              payload={payload}
            />
          </div>

        </div>
      </CSSTransition>
    </div>
  );
};
